import { RoundedRectangle } from "../atoms/roundedrectangle/RoundedRectangle"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { BodyLarge, BodySmall } from "../atoms/Bodies"
import { Spacer } from "../atoms/Atoms"
import { RetinaImage } from "../atoms/images/RetinaImage"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CarrotAndYourHealthcareModule = () => (
  <RoundedRectangle backgroundColor="dark-blue">
    <div className="flex flex-row justify-between items-center">
      <RetinaImage height={41} width={41} name="icn-medical" />
    </div>
    <Spacer height={0.5} />
    <BodyLarge color="white">{l`Carrot & your healthcare`}</BodyLarge>
    <Spacer height={0.5} />
    <BodySmall color="white">{l`Your benefit covers adoption and gestational carrier care and services only. Eligible fertility care providers can be found through WINFertility.`}</BodySmall>
  </RoundedRectangle>
)
export { CarrotAndYourHealthcareModule }
